import { useEffect, useState } from 'react';

import { Collapse } from '@mui/material';
import { EstablishmentBlockStyled } from '../establishment-block.styled';
import EstablishmentFormFooter from '../EstablishmentFormFooter';
import Jpaper from '@atoms/JPaper';
import { VideoCard } from '../VideoCard';
import VideoUpload from '@atoms/VideoUpload';
import useEstablishmentMutation from '@establishment/hooks/useEstablishmentMutation';

interface EstablishmentFormDetailsProps {
  includeFooter?: boolean;
}
const EstablishmentFormVideo = ({
  includeFooter,
}: EstablishmentFormDetailsProps) => {
  const { payload, setPayload, enterprise, mode, establishment, setIsDirty } =
    useEstablishmentMutation();
  const [video, setVideo] = useState<File | undefined>(payload?.video);
  const [isEnterpriseVideoSelected, setIsEnterpriseVideoSelected] = useState<
    boolean | null
  >(null);
  const [thumbnail, setThumbnail] = useState<File | undefined>(
    payload?.thumbnail,
  );

  useEffect(() => {
    setPayload((prev) => {
      return {
        ...prev,
        video,
      };
    });
  }, [video]);

  useEffect(() => {
    setPayload((prev) => {
      return {
        ...prev,
        thumbnail,
      };
    });
  }, [thumbnail]);

  const onVideoDelete = () => {
    setVideo(undefined);
    setThumbnail(undefined);
    setPayload((prev) => {
      return {
        ...prev,
        video: undefined,
        videoUrl: undefined,
        thumbnail: undefined,
        thumbnailUrl: undefined,
      };
    });
  };
  const setWithVideoEnterprise = (isEnterpriseSelected: boolean) => {
    setIsEnterpriseVideoSelected(isEnterpriseSelected);
    if (isEnterpriseSelected) {
      setIsDirty(true);
      setPayload((prev) => ({
        ...prev,
        videoUrl: enterprise?.videoUrl,
        thumbnailUrl: enterprise?.thumbnailUrl,
      }));
    } else {
      setPayload((prev) => ({
        ...prev,
        videoUrl: establishment?.videoUrl ?? undefined,
        thumbnailUrl: establishment?.thumbnailUrl ?? undefined,
      }));
    }
  };

  return (
    <>
      <EstablishmentBlockStyled>
        <Jpaper gap={1} alignItems="stretch" attr={{ fullHeight: true }}>
          <Collapse
            in={isEnterpriseVideoSelected === null || isEnterpriseVideoSelected}
            {...(isEnterpriseVideoSelected === null || isEnterpriseVideoSelected
              ? { timeout: 1000 }
              : {})}
          >
            <VideoCard
              mode={mode}
              isSelected={!!isEnterpriseVideoSelected}
              videoUrl={enterprise?.videoUrl}
              thumbnailUrl={enterprise?.thumbnailUrl}
              createdAt={enterprise?.createdAt}
              onSelect={(value) => setWithVideoEnterprise(value)}
            />
          </Collapse>
          <Collapse
            in={
              isEnterpriseVideoSelected !== null && !isEnterpriseVideoSelected
            }
            {...(isEnterpriseVideoSelected !== null &&
            !isEnterpriseVideoSelected
              ? { timeout: 1000 }
              : {})}
          >
            <div>
              <VideoUpload
                urlVideoValue={payload?.videoUrl}
                urlThumbnailValue={payload?.thumbnailUrl}
                value={payload?.video}
                onVideoUpload={(value) => {
                  setVideo(value);
                  setIsDirty(true);
                }}
                onThumbnailUpload={(value) => {
                  setThumbnail(value);
                  setIsDirty(true);
                }}
                onVideoDelete={onVideoDelete}
              />
            </div>
          </Collapse>
        </Jpaper>
      </EstablishmentBlockStyled>
      {includeFooter && (
        <EstablishmentFormFooter
          submitTab
          isValid={
            !!(payload?.videoUrl && payload.thumbnailUrl) ||
            !!(video && thumbnail) ||
            !!isEnterpriseVideoSelected
          }
          values={{ video, thumbnail }}
        />
      )}
    </>
  );
};

export default EstablishmentFormVideo;
